import RuleIcon from '@mui/icons-material/Rule';
import { Box, Button, Stack, Typography } from '@mui/material';
import Loader from 'components/Loader';
import pluralize from 'pluralize';
import React, { FunctionComponent } from 'react';
import type { StudyWorkflowStepMetric } from '../Workflow/studyWorkflowInventory';
import { WorkflowStepMetrics } from '../Workflow/WorkflowStepMetrics';

interface ManifestDraftStatusProps {
  isLoading: boolean;
  loadingMessage: string;
  metrics: StudyWorkflowStepMetric[];
  onReviewUnresolvedRows: () => void;
  unresolvedRowCount: number;
}

const formatCount = (count: number, label: string) => pluralize(label, count, true);

export const ManifestDraftStatus: FunctionComponent<ManifestDraftStatusProps> = ({
  isLoading,
  loadingMessage,
  metrics,
  onReviewUnresolvedRows,
  unresolvedRowCount,
}) => (
  <Box
    aria-live="polite"
    data-testid="manifest-draft-status"
    role="status"
    sx={{ px: 2, py: 1, borderTop: 1, borderColor: 'divider' }}
  >
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
      {isLoading ? <Loader inline message={loadingMessage} /> : <WorkflowStepMetrics metrics={metrics} />}
      {unresolvedRowCount > 0 && (
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="body2">{formatCount(unresolvedRowCount, 'unresolved row')}</Typography>
          <Button size="small" variant="text" color="inherit" startIcon={<RuleIcon />} onClick={onReviewUnresolvedRows}>
            Review unresolved rows
          </Button>
        </Stack>
      )}
    </Stack>
  </Box>
);
